import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useTemplates, type TemplateSummary } from '../../../api/templates';
import { useEnumLabel } from '../../../api/enums';
import { Table } from '../../../components/idsk';
import { PageHeading } from '../../../layout/PageHeading';
import { usePageTitle } from '../../../layout/usePageTitle';
import { formatDateTime } from '../../../lib/format';
import { QueryError } from '../../common/QueryError';
import { Loading } from '../../common/LoadingPage';
import { RequireAdmin } from '../../common/RequireAdmin';

export function TemplatesPage() {
  return (
    <RequireAdmin>
      <Templates />
    </RequireAdmin>
  );
}

function Templates() {
  const { t } = useTranslation();
  const label = useEnumLabel();
  const query = useTemplates();
  usePageTitle([t('templates.title')]);
  return (
    <>
      <PageHeading>{t('templates.title')}</PageHeading>
      <p className="govuk-body">{t('templates.intro')}</p>
      {query.error ? (
        <QueryError error={query.error} />
      ) : query.isPending ? (
        <Loading />
      ) : (
        <Table<TemplateSummary>
          caption={t('templates.caption')}
          rows={query.data}
          rowKey={(r) => r.formType}
          columns={[
            {
              key: 'form',
              header: t('templates.form'),
              rowHeader: true,
              render: (r) => (
                <Link className="govuk-link" to={`/sablony/${r.formType}`}>
                  {label('formTypes', r.formType)}
                </Link>
              ),
            },
            {
              key: 'published',
              header: t('templates.published'),
              render: (r) => (r.published ? t('templates.versionPublished', { n: r.published.versionNo, when: formatDateTime(r.published.publishedAt), who: r.published.publishedBy }) : '–'),
            },
            { key: 'draft', header: t('templates.draft'), render: (r) => (r.draft ? t('templates.versionDraft', { n: r.draft.versionNo }) : t('templates.noDraft')) },
            { key: 'count', header: t('templates.versionCount'), numeric: true, render: (r) => r.versionCount },
          ]}
        />
      )}
    </>
  );
}
